export const TransactionCategories = [
  { text: '1st Presentment (FP)', value: 'FirstPresentment' },
  { text: '2nd Presentment (SP)', value: 'SecondPresentment' },
  { text: 'Retrieval Request Advice (RRQA)', value: 'RRQAdvice' },
  { text: 'Retrieval Request Response (RRR)', value: 'RetrievalRequestResponse' },
  { text: 'Financial Advice (FA)', value: 'FinancialAdvice' },
  { text: 'Financial Reversal Advice (FRA)', value: 'FinancialReversalAdvice' },
  { text: 'Fee Advice (FEA)', value: 'FeeAdvice' },
  { text: 'Fee Collection (FEC)', value: 'FeeCollection' },
  { text: 'Adjustment (A)', value: 'Adjustment' }
]
